/**
 * Coreografia do redesign de Clientes (seção 5 do handoff): curvas, durações
 * e cascata. Só `transform`, `opacity` e `filter`; o MotionConfig global já
 * respeita `prefers-reduced-motion` e a preferência "animações" do ERP.
 */
export const CURVA_ENTRADA = [0.2, 0.8, 0.2, 1];
export const CURVA_PAINEL = [0.32, 0.72, 0, 1];
export const CURVA_SAIDA = [0.4, 0, 1, 1];
export const MOLA = { type: "spring", stiffness: 380, damping: 32, mass: 0.9 };

export const DURACAO = Object.freeze({
  micro: 0.15,
  componente: 0.28,
  painel: 0.4,
  saidaComponente: 0.2,
  saidaPainel: 0.26,
  barras: 0.6,
});

/** No máximo 8 itens em cascata; os demais entram junto com o 8º. */
const MAXIMO_EM_CASCATA = 8;
export function atrasoEmCascata(indice, passo = 0.035, base = 0) {
  return base + Math.min(indice, MAXIMO_EM_CASCATA) * passo;
}

/** Entrada de cards e indicadores: fade + 10 px + blur 4 → 0. */
export const ENTRADA_DE_CARD = {
  inicial: { opacity: 0, y: 10, filter: "blur(4px)" },
  final: { opacity: 1, y: 0, filter: "blur(0px)" },
};

export function transicaoDeCard(indice, base = 0) {
  return { duration: DURACAO.componente, ease: CURVA_ENTRADA, delay: atrasoEmCascata(indice, 0.04, base) };
}

export function prefereMenosMovimento() {
  try {
    return Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches)
      || document.documentElement.dataset.animacoes === "off";
  } catch {
    return false;
  }
}
